// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Ghana from '../_raw/flag/icon_flag_ghana.png';

export default () => <img src={Ghana} alt="Ghana" />;
